import { Link } from "react-router-dom";
import { Card, Text, Button } from "../../../Components/Index";
import useLatestServicesPreview from "./useLatestServicesPreview";
import LatestServiceItem from "./LatestServiceItem";
import LatestServicesEmptyState from "./LatestServicesEmptyState";
import "./latestServicesPreview.scss";

function LatestServicesPreview({ limit = 3 }) {
  const { services, loading, error, reload, selectedCar } =
    useLatestServicesPreview(limit);

  const vehicleName = selectedCar?.CarModel || "";
  const showList = !loading && !error && services.length > 0;
  const showEmpty = !loading && !error && services.length === 0;

  return (
    <Card className="LatestServicesPreview">
      <div className="LatestServicesPreview__header" dir="rtl">
        <Text FontWight="Bold" position="right">
          سرویس های رو به پایان
        </Text>
      </div>

      {loading && (
        <div
          className="LatestServicesPreview__status"
          dir="rtl"
          role="status"
        >
          <span
            className="LatestServicesPreview__spinner"
            aria-hidden
          />
          <Text position="center" color="gray">
            در حال بارگذاری سرویس‌ها...
          </Text>
        </div>
      )}

      {!loading && error && (
        <div className="LatestServicesPreview__status" dir="rtl">
          <Text position="center" color="red">
            {error}
          </Text>
          <Button size="mini" color="dark" onClick={reload}>
            تلاش مجدد
          </Button>
        </div>
      )}

      {showList && (
        <ul className="LatestServicesPreview__list">
          {services.map((service) => (
            <LatestServiceItem
              key={`preview-${service.id}`}
              service={service}
              vehicleName={vehicleName}
            />
          ))}
        </ul>
      )}

      {showEmpty && <LatestServicesEmptyState />}

      <div
        className="LatestServicesPreview__footer"
        dir="rtl"
      >
        <Link to="/LatestServices">
          <Button>دیدن جزئیات</Button>
        </Link>
      </div>
    </Card>
  );
}

export default LatestServicesPreview;
